import { formatCurrency } from './formatters';

export const shareProductOnWhatsApp = (product, appUrl) => {
  const productUrl = `${appUrl}/products/${product.id}`;
  
  const message = `*${product.name}*\n\n` +
    `📦 Category: ${product.category}\n` +
    `💰 Price: ${formatCurrency(product.recommended_selling_price)} per unit\n` +
    `📊 MOQ: ${product.moq} units\n` +
    `✅ Stock: ${product.stock_status}\n` +
    `🚚 Delivery: ${product.delivery_timeline}\n\n` +
    `View full details: ${productUrl}\n\n` +
    `_Powered by Consortium Gifts_`;
  
  const encodedMessage = encodeURIComponent(message);
  const whatsappUrl = `https://wa.me/?text=${encodedMessage}`;
  
  window.open(whatsappUrl, '_blank');
};
